module.exports = __webpack_public_path__ + "media/images/pic/team-780f9080bcc514ead717f63e724ee10f.svg";